// extracted by mini-css-extract-plugin
module.exports = {"dropDownPosition":"SectionDropdown_dropDownPosition_8sBf2"};